export default "__VITE_ASSET__c32031ac__"